import { DataTableSortStatus } from "mantine-datatable";
import { ReactNode } from "react";

export const SolutionStatus: any = {
  new: "New",
  backlog: "Backlog",
  planned: "Planned",
  "in-progress": "In Progress",
  beta: "Beta",
  production: "Production",
  canceled: "Canceled",
};

export const RequestStatus: any = {
  validated: "Validated",
  new: "New",
  rejected: "Rejected",
  "loop-closed": "Loop Closed",
};

export const SolutionPriority: any = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const IdeaPriority: any = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const RequestPriority: any = {
  "deal-breaker": "Deal Breaker",
  important: "Important",
  medium: "Medium",
  "nice-to-have": "Nice To Have",
};

export interface Column {
  enabled: boolean;
  /* index: number; */
  accessor: string;
  /* title: string; */
  sortable: boolean;
  /* textAlignment: string;
  renderComponent: string;
  renderParams: any; */
  draggable?: boolean;
  resizable?: boolean;
  width?: number | string;
  ellipsis?: boolean;

}



export type syncContextType = {
  account: any
  fieldsLoaded: boolean;
  deliveryPlatform: any;
  fields: any;
  components: any;
  ideaStatuses: any;
  ideaPriorities: any;
  requestPriorities: any;
  logout: any;
  members: any;
  owners: any;
  objectCustomizations: any;
  editCustomizations: any;
  defaultPriority: any;
  defaultStatus: any;
  enableEditOnImportedIdeas: boolean;
  showWhatsNewBanner: boolean | null;
  getFields: any;
  priorityData: any;
  enableIdeaValidation: boolean;
  showDomain: boolean;
  domains: any[];
  requestPrioritiesColors: any;
  defaultRequestPriority: any;
  accountAdditionalInfo: any;
  opportunityAdditionalInfo: any;
  evidenceDomain: boolean;
  displayState: any;
  allComponents: any[];
  businessCategoryMapping: any;
  currentAccount: any;
  ideasTableDisplay: any;
  customEvidenceObj: any;
  accountDoc: any;
  allAggregationProperties: any;
  impactAggregationProperties: any;
  perspectiveConfigurations: any[];
  ideaColumns: any[];
  ideaDefaultSortColumn: string | null,
  subPages: any[],
  setIdeasFiltersConfig: React.Dispatch<React.SetStateAction<{
    evidence: any;
    idea: any;
  }>> | null;
  ideasFiltersConfig: {
    evidence:any,
    idea:any
  };
  markedDeliveryStatus: any; 
  setMarkedDeliveryStatus: any;
  setAllComponents: (components: any[]) => void;
  ideaInfoTabsConfig: any;
  addedAttributes: any[];
  tagsList: any[];
  tagsOptions: any[];
  discoveryEvidencesSources :string[];
  fetchTags: any;
  gtmAppsConfiguration: any | null;
  generatedEnabled: boolean;
  threeSixtyColumns: any[];
  threeSixtyEnabled: boolean;
  threeSixtyConfig: any;
  setThreeSixtyConfig: React.Dispatch<React.SetStateAction<any>>;
  allColumns: any[];
  setAllColumns: React.Dispatch<React.SetStateAction<any[]>>;
  setFields: React.Dispatch<React.SetStateAction<any>>;
};

export type ChildProps = {
  children?: React.ReactNode;
};

export const jiraTypes: any = [
  {
    label: "cascadingselect",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect",
  },
  {
    label: "datepicker",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:datepicker",
  },
  {
    label: "datetime",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:datetime",
  },
  {
    label: "float",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:float",
  },
  {
    label: "grouppicker",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:grouppicker",
  },
  {
    label: "importid",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:importid",
  },
  {
    label: "labels",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:labels",
  },
  {
    label: "multicheckboxes",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes",
  },
  {
    label: "multigrouppicker",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker",
  },
  {
    label: "multiselect",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:multiselect",
  },
  {
    label: "multiuserpicker",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker",
  },
  {
    label: "multiversion",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:multiversion",
  },
  {
    label: "project",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:project",
  },
  {
    label: "radiobuttons",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons",
  },
  {
    label: "readonlyfield",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield",
  },
  {
    label: "select",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:select",
  },
  {
    label: "textarea",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:textarea",
  },
  {
    label: "textfield",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
  },
  {
    label: "url",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:url",
  },
  {
    label: "userpicker",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:userpicker",
  },
  {
    label: "version",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:version",
  },
];

export const jiraSearcherKeys: any = [
  {
    label: "cascadingselectsearcher",
    value:
      "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselectsearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect",
    ],
  },
  {
    label: "daterange",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:daterange",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:datepicker"],
  },
  {
    label: "datetimerange",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:datetimerange",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:datetime"],
  },
  {
    label: "exactnumber",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:exactnumber",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:float",
      "com.atlassian.jira.plugin.system.customfieldtypes:importid",
    ],
  },
  {
    label: "grouppickersearcher",
    value:
      "com.atlassian.jira.plugin.system.customfieldtypes:grouppickersearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:grouppicker",
    ],
  },
  {
    label: "labelsearcher",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:labelsearcher",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:labels"],
  },
  {
    label: "multiselectsearcher",
    value:
      "com.atlassian.jira.plugin.system.customfieldtypes:multiselectsearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes",
      "com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker",
      "com.atlassian.jira.plugin.system.customfieldtypes:multiselect",
      "com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons",
      "com.atlassian.jira.plugin.system.customfieldtypes:select",
    ],
  },
  {
    label: "userpickergroupsearcher",
    value:
      "com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker",
      "com.atlassian.jira.plugin.system.customfieldtypes:userpicker",
    ],
  },
  {
    label: "versionsearcher",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:multiversion",
      "com.atlassian.jira.plugin.system.customfieldtypes:version",
    ],
  },
  {
    label: "projectsearcher",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:projectsearcher",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:project"],
  },
  {
    label: "textsearcher",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:textsearcher",
    jiraTypes: [
      "com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield",
      "com.atlassian.jira.plugin.system.customfieldtypes:textarea",
      "com.atlassian.jira.plugin.system.customfieldtypes:textfield",
    ],
  },
  {
    label: "numberrange",
    value: "com.atlassian.jira.plugin.system.customfieldtypes:numberrange",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:float"],
  },
  {
    label: "exacttextsearcher",
    value:
      "com.atlassian.jira.plugin.system.customfieldtypes:exacttextsearcher",
    jiraTypes: ["com.atlassian.jira.plugin.system.customfieldtypes:url"],
  },
];

export interface BarProps {
  displayContent: ReactNode;
  barWidthPercantage: number

}

export type IdeasContextType = {
  location: any;
  page: string | null;
  filters: any;
  sortStatus: any;
  savedViews: any[];
  selectedView: any;
  requestsTotalCount: number;
  setRequestsTotalCount: React.Dispatch<React.SetStateAction<number>>;
  setPage: React.Dispatch<React.SetStateAction<string | null>>;
  setFilters: React.Dispatch<React.SetStateAction<string | null>>;
  setSortStatus: React.Dispatch<React.SetStateAction<DataTableSortStatus>>;
  setSelectedView: React.Dispatch<React.SetStateAction<any>>;
  loadViews: (deleted?: boolean) => void;
  upsertView: (body: any, callback: (res: any) => void) => void;
  sortState: string;
  setSortState: React.Dispatch<React.SetStateAction<string>>;
  isTagsHovered: boolean;
  hoverTags: (e: any, id: string) => void;
  hoveredId: string;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  ideas: any[];
  setIdeas: React.Dispatch<React.SetStateAction<any[]>>;
  getFilteredIdeas: () => void;
  tableColoumns: any[];
  isArchived: boolean;
  setIsArchived: React.Dispatch<React.SetStateAction<boolean>>;
  opened: boolean;
  openCustomizationModal: (type: 'evidence' | 'idea') => void;
  closeCustomizationModal: () => void;
  modalType: 'evidence' | 'idea' | null;
};

export const initialState: IdeasContextType = {
  location: null,
  page: null,
  filters: null,
  sortStatus: null,
  savedViews: [],
  selectedView: {},
  requestsTotalCount: 0,
  setRequestsTotalCount: () => null,
  setPage: () => null,
  setFilters: () => null,
  setSortStatus: () => null,
  setSelectedView: () => null,
  loadViews: () => null,
  upsertView: () => null,
  sortState: "",
  setSortState: () => null,
  isTagsHovered: false,
  hoverTags: () => null,
  hoveredId: "",
  search:'',
  setSearch: () => null,
  loading: false,
  setLoading: () => null,
  ideas: [],
  setIdeas: () => null,
  getFilteredIdeas: () => null,
  tableColoumns: [],
  isArchived: false,
  setIsArchived: () => null,
  opened: false,
  openCustomizationModal: () => null,
  closeCustomizationModal: () => null,
  modalType: null
};

export type DashboardContextType = {
  surgingIdeas: any[];
  filteredSurgingIdeas: any[];
  pluningIdeas: any[];
  filteredPluningIdeas: any[];
  chosenIdea: any;
  chooseIdea: (id: string) => void;
  components: any[];
  domains: any[];
  allComponents: any[];
  displayState: any;
  owners: any[];
  ownerName: string;
  setOwnerName: React.Dispatch<React.SetStateAction<string>>;
  ownerId: string | null;
  setOwnerId: React.Dispatch<React.SetStateAction<string| null>>;
  domain: string;
  setDomain: React.Dispatch<React.SetStateAction<string>>;
  componentName: string | undefined
  setComponentName: React.Dispatch<React.SetStateAction<string| undefined>>; 
  filterComponentByDomain: (domain: string | string[]) => void;
  componentsByDomain: any[];
  perspectiveConfigurations: any[];
  perspective: any;
  setPerspective: React.Dispatch<React.SetStateAction<any>>; 
  perspectiveIdeaData: any;
  componentId: string | null;
  setComponentId: React.Dispatch<React.SetStateAction<string| null>>;
  activeTab: string | null;
  setActiveTab: React.Dispatch<React.SetStateAction<string| null>>;
  chosenStatus: string | undefined
  setChosenStatus: React.Dispatch<React.SetStateAction<string>>;
  trendsActiveFilters: any[];
  setTrendsActiveFilters: React.Dispatch<React.SetStateAction<any[]>>;   
  ideaStatuses: any[];
};

export const dashboardInitialState: DashboardContextType = {
  
  surgingIdeas: [],
  filteredSurgingIdeas: [],
  pluningIdeas: [],
  filteredPluningIdeas: [], 
  chosenIdea: {},
  chooseIdea: () => null,
  components: [],
  domains: [],
  allComponents: [],
  displayState: {},
  owners: [],
  ownerName: '',
  setOwnerName: () => null,
  ownerId: null,
  setOwnerId: () => null,
  domain: '',
  setDomain: () => null,
  componentName: '',
  setComponentName: () => null,
  filterComponentByDomain: () => null,
  componentsByDomain: [],
  perspectiveConfigurations: [],
  perspective: {},
  setPerspective: () => null,
  perspectiveIdeaData: {},
  componentId: null,
  setComponentId: () => null,
  activeTab: '',
  setActiveTab: () => null,
  chosenStatus: '',
  setChosenStatus: () => null,
  trendsActiveFilters: [],
  setTrendsActiveFilters: () => null,
  ideaStatuses: [],
};

export type CustomersContextType = {
  customers: any[];
  chosenCustomer: any;
  chosenCustomerId: string;
  setChosenCustomer: React.Dispatch<React.SetStateAction<any>>; 
  evidences: any[];
  accountsResults: any[];
  account: any;
  accountName: string;
  setAccountName: React.Dispatch<React.SetStateAction<string>>; 
  setAccount: React.Dispatch<React.SetStateAction<any>>;
  cardOpened: boolean;
  setCardOpened: React.Dispatch<React.SetStateAction<any>>;
  chosenEvidence: any;
  setChosenEvidence: React.Dispatch<React.SetStateAction<any>>;
  ideasFiltersConfig: {
    evidence:any,
    idea:any
  };
};

export const customersInitialState: CustomersContextType = {
  customers: [],
  chosenCustomer: {},
  chosenCustomerId: '',
  setChosenCustomer: () => null,
  evidences: [],
  accountsResults: [],
  account: {},
  accountName: '',
  setAccountName: () => null,
  setAccount: () => null,
  cardOpened: true,
  setCardOpened: () => null,
  chosenEvidence: {},
  setChosenEvidence: () => null,
  ideasFiltersConfig: {
    evidence: {},
    idea: {},
  },
};

export interface SingleCustomerContextType {
  ideas: any[],
  ideaStatuses: any[],
  allComponents: any[],
  customer: any,
  cardOpened: boolean,
  setCardOpened: React.Dispatch<React.SetStateAction<boolean>>,
  chosenEvidence: any,
  setChosenEvidence: React.Dispatch<React.SetStateAction<any>>,
  threeSixtyColumns: any[],
  activeFilters: any[],
  setActiveFilters: React.Dispatch<React.SetStateAction<any[]>>,
  textQuery: string,
  setTextQuery: React.Dispatch<React.SetStateAction<string>>,
  customersItems: any[],
  setCustomersItems: React.Dispatch<React.SetStateAction<any[]>>,
  totalCustomersCount: number,
  chosenCustomer: any,
  setChosenCustomer: React.Dispatch<React.SetStateAction<any>>,
  isModalOpen: boolean,
  openModal: () => void,
  closeModal: () => void,
  account: any;
  accountName: string;
  setAccountName: React.Dispatch<React.SetStateAction<string>>; 
  setAccount: React.Dispatch<React.SetStateAction<any>>;
  comments: any[]
  setComments: React.Dispatch<React.SetStateAction<any[]>>,
  getUnreadNotificationsCountByRequest: (requestId: string) => number,
  getUnreadNotifications: () => void,
  unreadNotificationsLoading: boolean,
  ideaId: string | null,
  setIdeaId: React.Dispatch<React.SetStateAction<string | null>>,
  activityOpened: boolean,
  setActivityOpened: (value: boolean) => void,
  openActivity: () => void,
  chosenIdea: any,
  setChosenIdea: React.Dispatch<React.SetStateAction<any>>,
  domains: any[],
  isLoading: boolean,
  ideasLoading: boolean,
  threeSixtyConfig: any,
  setThreeSixtyConfig: React.Dispatch<React.SetStateAction<any>>,
  customerIds: string[],
  setCustomerIds: React.Dispatch<React.SetStateAction<string[]>>,
  customers: any[],
  setCustomers: React.Dispatch<React.SetStateAction<any[]>>,
  loadIdea: () => void,
  chosenCustomers: any[],
  evidences: any[],
  evidenceId: string,
  setEvidenceId: React.Dispatch<React.SetStateAction<string>>,
  fetchSingleCustomerEvidence: (evidenceId: string) => void,
  loadingEvidence: boolean,
  setLoadingEvidence: React.Dispatch<React.SetStateAction<boolean>>,
  isMultipleCustomers: boolean,
  setIsMultipleCustomers: React.Dispatch<React.SetStateAction<boolean>>,
  isSegmentSelection: boolean,
  setIsSegmentSelection: React.Dispatch<React.SetStateAction<boolean>>,
  handleModalOpen: () => void,
  isSingleSelection: boolean,
  setIsSingleSelection: React.Dispatch<React.SetStateAction<boolean>>,
  ideasFiltersConfig: {
    evidence:any,
    idea:any
  },
  groupBy: string,
  setGroupBy: React.Dispatch<React.SetStateAction<string>>,
  isReadyForSelect: boolean,
  viewType: 'single' | 'multiple' | 'segment'
  setViewType: React.Dispatch<React.SetStateAction<'single' | 'multiple' | 'segment'>>,
  impactAggregationProperties: any [],
  ideaInfoTabsConfig: any
}

export const SinglecustomerInitialState: SingleCustomerContextType = {
  ideas: [],
  ideaStatuses: [],
  allComponents: [],
  customer: {},
  cardOpened: false,
  setCardOpened: () => null,
  chosenEvidence: {},
  setChosenEvidence: () => null,
  threeSixtyColumns: [],
  activeFilters: [],
  setActiveFilters: () => null,
  textQuery: '',
  setTextQuery: () => null,
  customersItems: [],
  setCustomersItems: () => null,
  totalCustomersCount: 0,
  chosenCustomer: {},
  setChosenCustomer: () => null,
  isModalOpen: false,
  openModal: () => null,
  closeModal: () => null,
  account: {},
  accountName: '',
  setAccountName: () => null,
  setAccount: () => null,
  comments: [],
  setComments: () => null,
  getUnreadNotificationsCountByRequest: () => 0,
  getUnreadNotifications: () => null,
  unreadNotificationsLoading: false,
  ideaId: null,
  setIdeaId: () => null,
  activityOpened: false,
  setActivityOpened: () => null,
  openActivity: () => null,
  chosenIdea: {},
  setChosenIdea: () => null,
  domains: [],
  isLoading: false,
  ideasLoading: false,
  threeSixtyConfig: {},
  setThreeSixtyConfig:() => null, 
  customerIds: [],
  setCustomerIds: () => null,
  customers: [],
  setCustomers: () => null,
  loadIdea: () => null,
  chosenCustomers: [],
  evidences: [],  
  evidenceId: '',
  setEvidenceId: () => null,
  fetchSingleCustomerEvidence: () => null,
  loadingEvidence: false,
  setLoadingEvidence: () => null,
  isMultipleCustomers: false,
  setIsMultipleCustomers: () => null,
  isSegmentSelection: false,
  setIsSegmentSelection: () => null,
  handleModalOpen: () => null,
  isSingleSelection: false,
  setIsSingleSelection: () => null,
  ideasFiltersConfig: {
    evidence: {},
    idea: {},
  },
  groupBy: '',
  setGroupBy: () => null,
  isReadyForSelect: true,
  viewType: 'single',
  setViewType: () => null,
  impactAggregationProperties: [],
  ideaInfoTabsConfig: {}
};

export interface FiltersAndSegmentsContextType { 
  ideasFiltersConfig: {
    evidence:any,
    idea:any
  },
  filtersTypesArr: any[],
  handleToggleFilterInPage: (property: string, parent: number, page: string, add: boolean)=> void
  perspectiveConfigurations: any[]
}

export const FiltersAndSegmentsInitialState: FiltersAndSegmentsContextType = {
  
  ideasFiltersConfig: {
    evidence: {},
    idea: {},
  },
  filtersTypesArr: [],
  handleToggleFilterInPage: () => null,
  perspectiveConfigurations: []
};